import React from 'react';
import './Illustrations.css';

/**
 * Revetall's fox head: the app icon, the favicon and the avatar in the chat, email and app
 * drawings. Same drawing as `public/favicon.svg` and `brand/revetall-icon.svg`; change them
 * together.
 * @param {Object} props
 * @param {string} props.className - Sets the size
 * @returns {JSX.Element} Decorative drawing
 */
function FoxAvatar({ className }) {
  return (
    <svg className={className} viewBox="4 4 92 92" aria-hidden="true" focusable="false">
      {/* Ears: orange, white inside, dark tips */}
      <path className="ill-fox" d="M16 46 L20 8 L46 28 Z" />
      <path className="ill-fox" d="M84 46 L80 8 L54 28 Z" />
      <path className="ill-white" d="M23 36 L25 18 L38 29 Z" />
      <path className="ill-white" d="M77 36 L75 18 L62 29 Z" />
      <path className="ill-navy" d="M19 18 L20 8 L30 16 Z" />
      <path className="ill-navy" d="M81 18 L80 8 L70 16 Z" />

      {/* Head with the white fox mask */}
      <path className="ill-fox" d="M12 50 Q12 22 50 22 Q88 22 88 50 Q88 72 66 86 Q50 96 34 86 Q12 72 12 50 Z" />
      <path
        className="ill-white"
        d="M17 57 Q31 50 42 61 Q47 67 50 67 Q53 67 58 61 Q69 50 83 57 Q81 72 64 81 Q50 89 36 81 Q19 72 17 57 Z"
      />

      {/* Eyes, a small nose and a tiny smile */}
      <circle className="ill-navy" cx="35" cy="48" r="5" />
      <circle className="ill-navy" cx="65" cy="48" r="5" />
      <path className="ill-navy" d="M45 65.5 Q50 62.5 55 65.5 Q53.5 70 50 70.5 Q46.5 70 45 65.5 Z" />
      <path className="ill-fox-smile" d="M46.5 74.5 Q50 77 53.5 74.5" />
    </svg>
  );
}

export default FoxAvatar;
